"use strict";
// Growth plugins: email marketing sync and product reviews — the two most
// installed add-on categories on Shopify and Wix (reviews: Judge.me #1;
// email: Klaviyo, Mailchimp).
//
//   forms.submitted ─────┐
//   funnels.lead.captured┼─▶ email-marketing ─▶ email-marketing.audienceSync@1 ─▶ klaviyo | mailchimp | brevo
//   shop.order.paid ─────┤      (consent: marketing opt-in only;
//   auth.user.created ───┘       buyers synced as customers, never subscribed without opt-in)
//
//   shop.order.paid ─▶ reviews: buyer may review purchased products (verified badge)
//   site ─▶ submit review ─▶ pending ─▶ owner approves ─▶ shown with star ratings
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVIEWS_PLUGIN = exports.BREVO_PLUGIN = exports.MAILCHIMP_PLUGIN = exports.KLAVIYO_PLUGIN = exports.EMAIL_MARKETING_PLUGIN = void 0;
exports.EMAIL_MARKETING_PLUGIN = {
    id: 'email-marketing',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Email marketing',
    description: 'Send leads, funnel opt-ins and customers to Klaviyo, Mailchimp or Brevo automatically.',
    icon: 'i-ph:envelope-open',
    surfaces: ['web-app'],
    agentCard: 'Email marketing: syncs form leads, funnel opt-ins and shop customers to Klaviyo/Mailchimp/Brevo — set up in Dunea, no code; add a marketing opt-in checkbox to forms.',
    declares: {
        'email-marketing.audienceSync': {
            major: 1,
            cardinality: 'many',
            description: 'Adds or updates a contact in an email marketing audience.',
            features: ['subscribe', 'tags', 'customProperties', 'doubleOptIn', 'events'],
        },
    },
    subscribes: ['forms.submitted', 'funnels.lead.captured', 'shop.order.paid', 'auth.user.created'],
    emits: {
        'email-marketing.contact.synced': { major: 1, description: 'A contact was added/updated in the provider.' },
    },
    permissions: ['db:own-tables'],
};
const emailProvider = (id, title, description, features, fields, host) => ({
    id,
    version: '1.0.0',
    kind: 'provider',
    trust: 'first-party',
    title,
    description,
    provides: { 'email-marketing.audienceSync': { major: 1, features } },
    permissions: [`network:${host}`],
    settings: [
        {
            id: 'account',
            title,
            fields: fields.map((f) => ({
                key: f.key,
                label: f.label,
                placeholder: f.placeholder,
                type: f.secret ? 'secret' : 'text',
                required: true,
            })),
        },
    ],
});
exports.KLAVIYO_PLUGIN = emailProvider('klaviyo', 'Klaviyo', 'Email & SMS for online stores.', { subscribe: true, tags: false, customProperties: true, doubleOptIn: true, events: true }, [
    { key: 'apiKey', label: 'Private API key', secret: true, placeholder: 'pk_…' },
    { key: 'listId', label: 'List ID', placeholder: 'AbC123' },
], 'a.klaviyo.com');
exports.MAILCHIMP_PLUGIN = emailProvider('mailchimp', 'Mailchimp', 'Newsletters and automations.', { subscribe: true, tags: true, customProperties: true, doubleOptIn: true }, [
    { key: 'apiKey', label: 'API key', secret: true, placeholder: 'abc123…-us21' },
    { key: 'audienceId', label: 'Audience ID', placeholder: 'a1b2c3d4e5' },
], 'api.mailchimp.com');
exports.BREVO_PLUGIN = emailProvider('brevo', 'Brevo', 'Email, SMS and WhatsApp campaigns (formerly Sendinblue).', { subscribe: true, customProperties: true, doubleOptIn: false }, [
    { key: 'apiKey', label: 'API key', secret: true, placeholder: 'xkeysib-…' },
    { key: 'listId', label: 'List ID', placeholder: '3' },
], 'api.brevo.com');
exports.REVIEWS_PLUGIN = {
    id: 'reviews',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Reviews',
    description: 'Star ratings and reviews with verified-buyer badges, moderation and review requests after delivery.',
    icon: 'i-ph:star',
    surfaces: ['web-app'],
    agentCard: 'Reviews: star ratings + reviews per product (or any page), verified buyers, owner moderation (skills/reviews.md).',
    subscribes: ['shop.order.paid', 'shop.order.fulfilled'],
    emits: {
        'reviews.submitted': { major: 1, description: 'A visitor submitted a review (pending moderation).' },
        'reviews.approved': { major: 1, description: 'The owner approved a review.' },
    },
    permissions: ['db:own-tables', 'email:send'],
    targets: {
        'web-app': {
            skills: ['reviews'],
            lockedPaths: ['frontend/worker/dunea/reviews.ts', 'frontend/src/dunea/reviews.tsx'],
            // The shared fetch/proxy runtime lives in payments' files.
            uses: ['frontend/worker/dunea/plugins-proxy.ts', 'frontend/src/dunea/payments.tsx'],
            detect: ['useReviews'],
            budgetGzipKb: 10,
        },
    },
};
